/* eslint-disable default-case */
import { getMakes } from "api/garage/getMakes";
import { getMakesByYear } from "api/garage/getMakesByYear";
import { getModelsByMake } from "api/garage/getModelsByMake";
import { getModelsByYearMake } from "api/garage/getModelsByYearMake";
import { getVehicleFitmentOptions } from "api/garage/getVehicleFitmentOptions";
import { getYearByMake } from "api/garage/getYearByMake";
import { getYearByMakeModel } from "api/garage/getYearByMakeModel";
import { checkItemFitmentApi } from "api/shopping-cart/checkItemFitmentApi";
import { IVehicle } from "interfaces/session/IVehicle";
import objectAssign from "object-assign";
import PropTypes from "prop-types";
import { PureComponent } from "react";
import { trackFitmentEvent } from "util/analytics/trackFitmentEvent";
import { TRACKING_EVENT_NAME } from "util/analytics/tracking.service";
import yieldAnalyticsEvent from "util/analytics/yieldAnalyticsEvent";
import { setLSItem } from "util/localStorageUtils";
import { refreshData } from "util/refreshData";
import { getYearRange } from "util/vehicle/getYearRange";
import { groupAttributeFn } from "util/vehicle/groupAttributeFn";
import { groupMakeFn } from "util/vehicle/groupMakeFn";
import { groupModelFn } from "util/vehicle/groupModelFn";
import { groupYearFn } from "util/vehicle/groupYearFn";
import { trackEvents } from "../../util/analytics/trackEvents";
import { groupArray } from "../../util/helper/groupArray";
import { capitalize } from "../../util/lodash/capitalize";
import { validateVehicle } from "../../util/vehicle/validate-vehicle";

import {
  ENGINE_TITLE,
  MAKE_MODEL_YEAR, MAKE_YEAR_MODEL, YEAR_MAKE_MODEL, YEAR_MAKE_MODEL_ENGINE,
} from "./constants";

export function restructureModel(data: any) {
  return groupArray(data, groupModelFn)
    .map((item: any) => ({
      label: item.key,

      options: item.data.map((model: any) => ({
        value: model.model,
        label: model.model,
      })),
    }));
}

export function restructureEngines(response: any) {
  const options = response.data.map((engine: string) => ({
    value: engine,
    label: engine,
  }));

  const engines = [{
    label: "ENGINES",
    options,
  }];

  return engines;
}

function restructureData(data: any, fun: any, key?: string) {
  const arr = groupArray(data, fun);
  return arr.map((item: any) => ({
    label: key ? key.concat("s") : item.key,

    options: item.data.map((keyitem: any) => ({
      value: keyitem,
      label: keyitem,
    })),
  }));
}

function modelsbyMakeTransForm(data: any) {
  const reStructured: any = [];
  data.forEach((group: any) => {
    group.models.forEach((model: any) => {
      reStructured.push({ bodyType: group.bodyType, model });
    });
  });
  return restructureModel(reStructured);
}

const propTypes = {
  selectionOrder: PropTypes.array,
  defaultYear: PropTypes.number,
  defaultMake: PropTypes.string,
  defaultModel: PropTypes.string,
  onSelectVehicle: PropTypes.func.isRequired,
};

const defaultProps = {
  selectionOrder: YEAR_MAKE_MODEL,
  defaultYear: undefined,
  defaultMake: undefined,
  defaultModel: undefined,
};

const defaultState = {
  disabledYears: false,
  disabledMakes: true,
  disabledModels: true,
  disabledEngines: true,
  selectedYear: undefined,
  selectedMake: undefined,
  selectedModel: undefined,
  selectedEngine: undefined,
  selectionOrder: YEAR_MAKE_MODEL,
  years: [],
  makes: [],
  models: [],
  engines: [],
  attributeOptions: [],
  nextAttribute: "",
  vehicle: {},
  loadingMake: false,
  loadingModel: false,
  loadingYear: false,
  loadingEngine: false,
  nextAttributeTitle: "",
};

class VehicleSelectorBase extends PureComponent {
  constructor(props: any) {
    super(props);

    let years = getYearRange().reverse();

    years = restructureData(years, groupYearFn);
    const {
      defaultYear, defaultMake, defaultModel, defaultEngine,
    } = this.props;
    this.state = {
      ...defaultState,
      selectedYear: defaultYear,
      selectedMake: defaultMake,
      selectedModel: defaultModel,
      selectedEngine: defaultEngine,
      selectionOrder: props.selectionOrder || YEAR_MAKE_MODEL,
      allYears: years,
      nextAttribute: props.nextAttribute,
      attributeOptions: props.attributeOptions,
    };

    this.handleSelectYear = this.handleSelectYear.bind(this);
    this.handleSelectMake = this.handleSelectMake.bind(this);
    this.handleSelectModel = this.handleSelectModel.bind(this);
    this.handleSelectEngine = this.handleSelectEngine.bind(this);
    this.handleSelectAttribute = this.handleSelectAttribute.bind(this);
    this.selectVehicleAndLoadNextAttribute = this.selectVehicleAndLoadNextAttribute.bind(this);
  }

  UNSAFE_componentWillMount() {
    const {
      defaultYear, defaultMake, defaultModel, selectionOrder, defaultEngine,
    } = this.props;

    const state = {
      selectedYear: defaultYear,
      selectedMake: defaultMake,
      selectedModel: defaultModel,
      selectedEngine: defaultEngine,
      selectionOrder,
      vehicle: this.props.garage.selectedVehicle,
    };
    this.updateState({}, state);
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (
      nextProps.selectionOrder.toString() !== this.props.selectionOrder.toString()
      || nextProps.defaultYear !== this.props.defaultYear
      || nextProps.defaultMake !== this.props.defaultMake
      || nextProps.defaultModel !== this.props.defaultModel
      || nextProps.attributeOptions !== this.props.attributeOptions
      || nextProps.focusEl !== this.props.focusEl
    ) {
      this.updateState(nextProps);
    }
  }

  updateState(nextProps = {}, nextState = {}) {
    // Using thirdy-part library since objectAssign has not been rendering
    // by Google crawl ( Just for things in constructor and componentWillMount )
    // eslint-disable-next-line no-param-reassign
    nextProps = objectAssign({}, this.props, nextProps);
    // eslint-disable-next-line no-param-reassign
    nextState = objectAssign({}, this.state, nextState, {
      selectionOrder: nextProps.selectionOrder,
      selectedMake: nextProps.defaultMake,
      selectedModel: nextProps.defaultModel,
      selectedEngine: nextProps.defaultEngine,
      selectedYear: nextProps.defaultYear,
    });

    if ([YEAR_MAKE_MODEL.toString(), YEAR_MAKE_MODEL_ENGINE.toString()].includes(nextProps.selectionOrder.toString())) {
      let years = getYearRange().reverse();

      years = restructureData(years, groupYearFn);

      // eslint-disable-next-line no-param-reassign
      nextState.years = years;
    }

    // if all 3 exists OR all 3 don't exists.

    if ((nextProps.defaultMake && nextProps.defaultModel && nextProps.defaultYear)

      || (!nextProps.defaultMake && !nextProps.defaultModel && !nextProps.defaultYear)
    ) {
      if (!nextProps.attributeOptions || nextProps.attributeOptions.length === 0) {
        this.setState(nextState);
        return;
      }

      const { focusEl } = nextProps;
      const selectionOrder = [focusEl];
      let title = capitalize(focusEl);
      if (title?.toLowerCase().includes("engine")) {
        title = "Engine";
      }
      const attributeOptions = restructureData(nextProps.attributeOptions, groupAttributeFn, capitalize(focusEl));

      this.setState({
        ...nextState, selectionOrder, attributeOptions, disabledYears: true, nextAttribute: focusEl, [`selected${focusEl}`]: undefined,
      });
      return;
    }

    // seemns not required.

    if (!nextProps.defaultMake && !nextProps.defaultModel && !nextProps.defaultYear) {
      this.setState({
        ...nextState,
        // [`disabled${capitalize(nextProps.selectionOrder[0])}s`]: false,
        // [`disabled${capitalize(nextProps.selectionOrder[1])}s`]: true,
        // [`disabled${capitalize(nextProps.selectionOrder[2])}s`]: true,
      });
      return;
    }

    if (nextProps.defaultMake && nextProps.defaultModel && nextProps.defaultYear) {
      this.setState({ ...nextState, disabledYears: true });

      if (nextProps.category) {
        this.loadNextAttribute({

          make: nextProps.defaultMake,

          model: nextProps.defaultModel,

          year: nextProps.defaultYear,
          fitmentOptions: [],
        });
      } else {
        this.setState({
          ...defaultState,

          selectionOrder: nextProps.selectionOrder || MAKE_YEAR_MODEL,

          years: nextState.allYears,
        });
      }
      return;
    }

    // If selection order is YEAR_MAKE_MODEL or YEAR_MAKE_MODEL_ENGINE & only make, model is present, clear them
    if ([YEAR_MAKE_MODEL.toString(), YEAR_MAKE_MODEL_ENGINE.toString()].includes(nextState.selectionOrder.toString()) && !nextState.selectedYear && nextState.selectedMake && nextState.selectedModel) {
      this.setState({
        selectedMake: undefined,
        selectedModel: undefined,
        selectedEngine: undefined,
      });
      return;
    }

    // If default make, model is changed, it should be updated in the state
    if (nextProps.defaultMake !== this.props.defaultMake || nextProps.defaultModel !== this.props.defaultModel || nextProps.selectionOrder !== this.props.selectionOrder) {
      this.setState({
        selectedMake: nextProps.defaultMake,
        selectedModel: nextProps.defaultModel,
        selectedEngine: nextProps.defaultEngine,
        selectionOrder: nextProps.selectionOrder,
      });
    }

    let __selectionOrder = nextState.selectionOrder;

    if ([nextProps.defaultMake, nextProps.defaultModel, nextProps.defaultYear].filter(Boolean).length === 2) {
      __selectionOrder = [nextState.selectionOrder[1]];
    }
    __selectionOrder.forEach((orderItem: any) => {
      if (orderItem === "make") {
        if (nextProps.defaultMake) {
          this.handleSelectMake(

            nextProps.defaultMake,
            nextProps,
            nextState,
            false,
          );
        } else {
          this.setState({
            selectedMake: undefined,
          });
        }
      }
      if (orderItem === "model") {
        if (nextProps.defaultModel) {
          this.handleSelectModel(
            nextProps.defaultModel,
            nextProps,
            nextState,
            false,
          );
        } else {
          this.setState({
            selectedModel: undefined,
          });
        }
      }

      if (orderItem === "engine") {
        if (nextProps.defaultEngine) {
          this.handleSelectEngine(
            nextProps.defaultEngine,
            nextProps,
            nextState,
            false,
          );
        } else {
          this.setState({
            selectedEngine: undefined,
          });
        }
      }

      if (orderItem === "year") {
        if (nextProps.defaultYear) {
          this.handleSelectYear(

            nextProps.defaultYear,
            nextProps,
            nextState,
            false,
          );
        } else {
          this.setState({
            selectedYear: undefined,
          });
        }
      }
    });
  }

  // handleSelect({ year, make, model }, props = {}, state = {}, fireCallback = true) {
  //   const { selectionOrder } = objectAssign({}, this.props, props);
  //   const { selectedMake } = objectAssign({}, this.state, state);

  //   switch (selectionOrder.toString()) {
  //   case YEAR_MAKE_MODEL.toString():
  //     break;
  //   case MAKE_YEAR_MODEL.toString():
  //     break;
  //   case MAKE_MODEL_YEAR.toString():
  //     break;
  //   }
  // }

  handleSelectYear(year: any, props = {}, state = {}, fireCallback = true) {
    const { selectionOrder } = objectAssign({}, this.props, props);
    const { selectedMake } = objectAssign({}, this.state, state);
    switch (selectionOrder.toString()) {
    case YEAR_MAKE_MODEL_ENGINE.toString():
    case YEAR_MAKE_MODEL.toString():
      getMakesByYear(year).then((response: any) => {
        const makes = restructureData(response.data, groupMakeFn);

        this.setState({
          selectedYear: year,
          selectedMake: undefined,
          disabledMakes: false,
          selectedModel: undefined,
          disabledModels: true,
          makes,
        });

        if (fireCallback) this.onCompleteYearRequest(year, response.data, "make");
      });
      break;

    case MAKE_YEAR_MODEL.toString():
      getModelsByYearMake(year, selectedMake)
        .then((response: any) => {
          const models = restructureModel(response.data);
          this.setState({
            selectedYear: year,
            selectModel: undefined,
            disabledModels: false,
            models,
          });

          if (fireCallback) this.onCompleteYearRequest(year, response.data, "model");
        }).catch((err: any) => {
          console.log(err);
        });

      break;

    case MAKE_MODEL_YEAR.toString(): {
      this.setState({
        selectedYear: year,
      });

      const vehicle = {
        year,
        make: this.state.selectedMake,
        model: this.state.selectedModel,
        fitmentOptions: [],
      };
      this.selectVehicleAndLoadNextAttribute(vehicle, fireCallback);
    }
      break;
    default:
      break;
    }
  }

  handleSelectMake(make: any, props = {}, state = {}, fireCallback = true) {
    const { selectionOrder } = objectAssign({}, this.props, props);
    const { selectedYear } = objectAssign({}, this.state, state);
    switch (selectionOrder.toString()) {
    case YEAR_MAKE_MODEL_ENGINE.toString():
    case YEAR_MAKE_MODEL.toString():
      getModelsByYearMake(selectedYear, make)
        .then((response: any) => {
          const models = restructureModel(response.data);
          this.setState({
            selectedMake: make,
            selectedModel: props.defaultModel || undefined,
            selectedEngine: props.defaultEngine || undefined,
            disabledModels: false,
            models,
          });

          if (fireCallback) this.onCompleteMakeRequest(make, response.data, "model");
        }).catch((err: any) => {
          console.log(err);
        });

      break;

    case MAKE_YEAR_MODEL.toString():
      getYearByMake(make).then((response: any) => {
        const years = restructureData(response.data.reverse(), groupYearFn);
        this.setState({
          selectedMake: make,
          selectedYear: undefined,
          disabledYears: false,
          selectedModel: undefined,
          disabledModels: true,
          years,
        });

        if (fireCallback) this.onCompleteMakeRequest(make, response.data, "year");
      });
      break;

    case MAKE_MODEL_YEAR.toString():
      getModelsByMake(make).then((response: any) => {
        const models = modelsbyMakeTransForm(response.data);
        this.setState({
          selectedMake: make,

          selectedModel: props.defaultModel || undefined,
          disabledModels: false,
          disabledYears: true,
          models,
        });

        if (fireCallback) this.onCompleteMakeRequest(make, response.data, "model");
      });
      break;
    default:
      break;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleSelectModel(model: any, props = {}, state = {}, fireCallback = true) {
    const { selectionOrder } = objectAssign({}, this.props, props);
    const { selectedMake } = objectAssign({}, this.state, state);
    switch (selectionOrder.toString()) {
    case YEAR_MAKE_MODEL.toString():
    case MAKE_YEAR_MODEL.toString(): {
      this.setState({
        selectedModel: model,
      });
      const vehicle = {
        year: this.state.selectedYear,
        make: this.state.selectedMake,
        model,
        fitmentOptions: [],
      };

      this.selectVehicleAndLoadNextAttribute(vehicle, fireCallback);
    }
      break;

    case YEAR_MAKE_MODEL_ENGINE.toString():
      const vehicle = {
        year: this.state.selectedYear,
        make: this.state.selectedMake,
        model,
        fitmentOptions: [],
      };
      getVehicleFitmentOptions(vehicle, ENGINE_TITLE)
        .then((response: any) => {
          const engines = restructureEngines(response);

          if (response.data?.length) {
            this.setState({
              selectedModel: model,
              engines,
              disabledEngines: false,
            });

            if (fireCallback) this.onCompleteModelRequest(model, response.data, "engine");
            // handle no engine info
          } else {
            this.setState({
              selectedModel: model,
            });

            this.selectVehicleAndLoadNextAttribute(vehicle, fireCallback);
          }
        });

      break;

    case MAKE_MODEL_YEAR.toString():
      getYearByMake(selectedMake)
        .then((response) => {
          const years = restructureData(response.data.reverse(), groupYearFn);

          this.setState({
            selectedModel: model,

            selectedYear: props.defaultYear || undefined,
            disabledYears: false,

            disabledModels: Boolean(props.defaultModel),
            years,
          });
          if (fireCallback) this.onCompleteMakeRequest(selectedMake, response.data, "year");
        });

      // getYearByMakeModel(selectedMake, model)
      //   .then((response: any) => {
      //     const years = restructureData(response.data.reverse(), groupYearFn);

      //     if (fireCallback) this.onCompleteModelRequest(model, response.data, "year");
      //   }).catch((err: any) => {
      //     console.log(err);
      //   });

      break;
    default:
      break;
    }
  }

  handleSelectEngine(engine: string) {
    this.setState({
      selectedEngine: engine,
    });
    const vehicle = {
      year: this.state.selectedYear,
      make: this.state.selectedMake,
      model: this.state.selectedModel,
      fitmentOptions: [
        {
          optionName: ENGINE_TITLE,
          optionValue: engine,
        },
      ],
    };
    this.selectVehicleAndLoadNextAttribute(vehicle, true);
  }

  selectVehicleAndLoadNextAttribute(vehicle: IVehicle, fireCallback: any) {
    const { category } = this.props;
    if (!validateVehicle(vehicle)) {
      return;
    }
    if (!category) {
      this.props.onSelectVehicle(vehicle);
      return;
    }
    if (!category.tier1) {
      this.props.onSelectVehicle(vehicle);
      return;
    }
    this.loadNextAttribute(vehicle, fireCallback);
  }

  postNextFitmentOption = (nextAttribute: string, nextAttributeTitle: string, nextFitmentAttributeOptions: string[], vehicle: IVehicle, fireCallback?: any) => {
    if (this.props.setVehicleDetails) {
      // todo: check if any bugs are there bcz of commenting this
      // this.props.setVehicleDetails(response);
    }

    if (nextFitmentAttributeOptions && Array.isArray(nextFitmentAttributeOptions) && nextFitmentAttributeOptions.length === 0) {
      this.props.onSelectVehicle({ ...vehicle });
      return;
    }

    const { selectionOrder: so } = this.state;
    let selectionOrder = so;
    if (!so.includes(nextAttribute)) {
      selectionOrder = [...so, nextAttribute];
    }
    if (this.props.draftVehcile) {
      this.props.draftVehcile({ ...vehicle });
      selectionOrder = [nextAttribute];
    }

    const { attributeOptions } = this.state;

    const nextAttributeOptions = restructureData(nextFitmentAttributeOptions, groupAttributeFn, nextAttribute);
    let updatedAttributeOptions = nextAttributeOptions;
    if (attributeOptions && attributeOptions.length > 0) {
      const filterOldAttributesOptions = attributeOptions.filter((attribute) => {
        if (attribute.label.toLowerCase() !== nextAttributeOptions[0].label.toLowerCase()) {
          return true;
        }
        return false;
      });
      updatedAttributeOptions = [...filterOldAttributesOptions, ...nextAttributeOptions];
    }

    // Somewhere vehicle might be mutated. That's why we sometimes it is double encoded & wrong vehicle is selected
    this.setState({
      selectionOrder,
      attributeOptions: updatedAttributeOptions,
      nextAttribute,
      vehicle: { ...vehicle },
      [`selected${nextAttribute}`]: undefined,
      nextAttributeTitle,
    });
    if (fireCallback) {
      this.onCompleteMakeRequest(null, null, nextAttribute, nextAttributeTitle);
    }
  };

  nextFitmentCallback = (vehicle: IVehicle, fireCallback?: any) => {
    if (fireCallback && this.props.onSelectVehicle) {
      trackEvents(
        TRACKING_EVENT_NAME.VEHICLE_SELECTED,
        "select",
        vehicle,
      );
    // this.props.onSelectVehicle(vehicle);
    }
  };

  // handleCategoryCallback = (actualResponse, vehicle: IVehicle) => {

  // };

  postRefreshData = (keysToUpdate, vehicle: IVehicle, fireCallback: any) => {
    const { fitmentOptionsPrompt = [], fitmentOptionsDetails = {} } = keysToUpdate;

    const [nextAttribute] = fitmentOptionsPrompt;
    if (!nextAttribute) { // When all fitment options are selected, select vehicle
      this.props.onSelectVehicle({ ...vehicle });
      if (this.props.setData) {
        this.props.setData(keysToUpdate, true);
      }
      return;
    }
    //
    const { fitmentOptionValues = [], title } = fitmentOptionsDetails[nextAttribute];

    const {
      tier0, tier1, tier2, tier3,
    } = this.props.utils.urlInformation;

    yieldAnalyticsEvent(() => trackFitmentEvent(TRACKING_EVENT_NAME.FITMENT_PROMPTED, {
      fitmentOptionName: nextAttribute,
      fitmentOptionTitle: title,
      unselectedFitments: fitmentOptionsPrompt,
      selectedFitments: vehicle.fitmentOptions.map((fo) => fo.optionName),
      tier0,
      tier1,
      tier2,
      tier3,
    }));

    if (this.props.setFitmentDeails) {
      this.props.setFitmentDeails({ fitmentOptionsPrompt, fitmentOptionsDetails });
    }
    this.postNextFitmentOption(nextAttribute, title, fitmentOptionValues, vehicle, fireCallback);
    this.nextFitmentCallback(vehicle, fireCallback);
  };

  skipFitmentLoading(vehicle: IVehicle) {
    this.props.onSelectVehicle({ ...vehicle });
    this.setState({
      vehicle: { ...vehicle },
    });
    // hideInlineVehicleSelector: hides inline vehicle selector from src/component/product/V2/fitment/ProductFitmentBox.tsx
    if (this.props.hideInlineVehicleSelector) {
      this.props.hideInlineVehicleSelector();
    }
  }

  loadNextAttribute(vehicle: IVehicle, fireCallback?: any, nextAttribute?: string, nextAttributeValue?: string) {
    const { category, skipFitmentOptions } = this.props;
    if (!validateVehicle(vehicle)) {
      return;
    }
    if (!category || !category.tier0) {
      return;
    }

    if (this.props.validateFitment) {
      checkItemFitmentApi(this.props.product.sku, vehicle).then(({ data }) => {
        if (data.fitmentStatus === "NO_FIT") {
          this.props.openModal("productNotFitModal", {
            product: this.props.product,
            ...data,
            nextAttribute,
            nextAttributeValue,
            postChangeSettings: () => {
              this.props.onSelectVehicle({
                make: decodeURIComponent(vehicle.make),
                model: decodeURIComponent(vehicle.model),
                year: decodeURIComponent(vehicle.year),
                fitmentOptions: vehicle.fitmentOptions,
              });
            },
          });
        } else {
          this.skipFitmentLoading(vehicle);
          setLSItem("category-scroll-to-product", this.props.product.sku);
        }
      });
      return;
    }

    // skipFitmentOptions: on category page product card, select vehicle when fitment option is selected & close vehicle selector
    // If not done, it will start showing up wrong fitment attributes in vehicle selector

    // on category page, when year, make, model is selected, just select the vehicle
    // If we don't select vehicle & make get-page-detail call, it will give redirect url
    // & fitment options will not be received from API
    // To reproduce: go to category page, add a new vehicle, after selecting vehicle, page will crash
    if (skipFitmentOptions || !validateVehicle(this.props.garage.selectedVehicle)) {
      this.skipFitmentLoading(vehicle);
      return;
    }

    // if (validateVehicle(this.props.garage.selectedVehicle)) {
    // todo: handle fitment title
    /*
      const fitmentTitle = selectedFitmentOptions
          .reduce((acc, fo) => (`${acc} ${fo.optionValue}`), "");
        this.props.setFitmentTitle(fitmentTitle);
        this.postNextFitmentOption(optionName, title, optionValues, vehicle, fireCallback);
        this.nextFitmentCallback(vehicle, fireCallback);
      */
    const { pathname } = this.props.router.query;

    // For product fitment box, select vehicle
    if (this.props.selectFitmentOptionOneByOne) {
      this.props.onSelectVehicle({ ...vehicle });
      return;
    }

    if (this.props.clientSideRefresh) {
      this.props.clientSideRefresh(vehicle)
        .then(({ keysToUpdate }) => {
          this.postRefreshData(keysToUpdate, vehicle, fireCallback);
        });
    } else {
      refreshData({
        pathname,
        isMobile: true,
        selectedVehicle: vehicle,
      }).then(({ keysToUpdate }) => {
        this.postRefreshData(keysToUpdate, vehicle, fireCallback);
      });
    }
    // } else {
    //   this.props.onSelectVehicle({ ...vehicle });
    // }
  }

  handleSelectAttribute(nextAttributeValue: any, item: string) {
    const { fitmentOptions = [] } = this.state.vehicle;
    const nextAttribute = item;
    // Tells whether we should update fitment option. If not, add new fitment option in array
    const shouldUpdateFitment = fitmentOptions.some((fo) => fo.optionName === nextAttribute);
    const updatedFitmentOptions = shouldUpdateFitment ? fitmentOptions
      .map((fo) => (fo.optionName === nextAttribute ? { ...fo, optionValue: nextAttributeValue } : { ...fo }))
      : [...fitmentOptions, { optionName: nextAttribute, optionValue: nextAttributeValue }];
    this.setState({
      [`selected${nextAttribute}`]: nextAttributeValue,
    });
    const vehicle = {
      year: this.state.selectedYear,
      make: this.state.selectedMake,
      model: this.state.selectedModel,
      engine: this.state.selectedEngine,
      ...this.state.vehicle,
      fitmentOptions: updatedFitmentOptions,
    };
    trackEvents(
      TRACKING_EVENT_NAME.VEHICLE_SELECTED,
      "select",
      vehicle,
    );
    const {
      tier0, tier1, tier2, tier3,
    } = this.props.utils.urlInformation;

    yieldAnalyticsEvent(() => trackFitmentEvent(
      TRACKING_EVENT_NAME.FITMENT_SELECTED,
      {
        fitmentOptionName: nextAttribute,
        fitmentOptionValue: nextAttributeValue,
        selectedFitments: vehicle.fitmentOptions.map((fo) => fo.optionName),
        tier0,
        tier1,
        tier2,
        tier3,
      },
    ));

    this.loadNextAttribute(vehicle, true, nextAttribute, nextAttributeValue);
  }

  loadData = ({
    selectionOrder,
    item,
  }: any) => new Promise((resolve) => {
    const { selectedYear, selectedMake } = this.state;
    let dataPromisefun;
    let trnasformFun = restructureData;
    if (item === "model") {
      switch (selectionOrder.toString()) {
      case MAKE_MODEL_YEAR.toString():
        dataPromisefun = getModelsByMake(this.state.selectedMake);
        trnasformFun = modelsbyMakeTransForm;
        break;
      case YEAR_MAKE_MODEL.toString():
      case MAKE_YEAR_MODEL.toString():
        if (!selectedYear || !selectedMake) {
          return;
        }
        dataPromisefun = getModelsByYearMake(selectedYear, selectedMake);
        trnasformFun = restructureModel;
        break;
      }
    } else if (item === "make") {
      switch (selectionOrder.toString()) {
      case MAKE_MODEL_YEAR.toString():
      case MAKE_YEAR_MODEL.toString():
        dataPromisefun = getMakes();

        trnasformFun = (data) => restructureData(
          data.actualResponse.makeWithUrls.map((_: any) => _.make),
          groupMakeFn,
        );
        break;
      case YEAR_MAKE_MODEL.toString():
        if (!selectedYear) {
          return;
        }
        dataPromisefun = getMakesByYear(selectedYear);

        trnasformFun = (data) => restructureData(data, groupMakeFn);
        break;
      }
    }

    if (dataPromisefun) {
      dataPromisefun
        .then((res: any) => {
          const finalData = trnasformFun(res.data);
          resolve(finalData);
        });
    }
  });

  handleFocus = (e: any, item: any) => {
    // setTimeout 0 was added to fix a bug
    // go to https://partsavatar.ca/chevrolet-silverado-3500-replacement-parts?year=2002&tier1=Cooling%20Systems
    // change vehicle from from vehicle selector modal with prefilled make model
    // select Dodge from make, the models that are loaded are of chevrolet not dodge.
    // This happens bcz makes is not yet set & handleFocus is run

    setTimeout(() => {
      const itemStateMap = {
        make: this.state.makes,
        model: this.state.models,
        year: this.state.years,
        engine: this.state.engines,
      };

      if (itemStateMap[item]?.length === 0) {
        const { selectionOrder } = this.props;
        this.setState({ [`loading${capitalize(item)}`]: true });
        this.loadData({ selectionOrder, item })
          .then((newData) => {
            this.setState({
              [`${item}s`]: newData,
              [`loading${capitalize(item)}`]: false,
            });
          });
      }
    }, 0);
  };

  loadNextAttributeFunctionHandler = (value: any, item: any) => {
    const { selectionOrder } = this.state;
    const itemHandlerMap = {
      make: this.handleSelectMake,
      model: this.handleSelectModel,
      year: this.handleSelectYear,
      engine: this.handleSelectEngine,
    };

    const func = itemHandlerMap[item] || this.handleSelectAttribute;
    const loadingOptionIndex = selectionOrder.indexOf(item) + 1;
    if (selectionOrder[loadingOptionIndex]) {
      this.setState({ [`loading${capitalize(selectionOrder[loadingOptionIndex])}`]: true });
    }
    func(value, item);
  };

  handleSelect = (value: any, item: any) => {
    const { selectionOrder, selectedMake, selectedModel } = this.state;

    if (value && item === "year" && selectionOrder.toString() === MAKE_MODEL_YEAR.toString()) {
      getYearByMakeModel(selectedMake, selectedModel).then(({ data }) => {
        if (!data.includes(value.toString()) && this.props.yearNotFitInModelHandler) {
          this.props.yearNotFitInModelHandler({ selectedYear: value, selectedMake });
          setTimeout(() => {
            this.onCompleteYearRequest(value, data, "model");
          }, 1000);
        } else {
          this.loadNextAttributeFunctionHandler(value, item);
        }
      });
    } else {
      this.loadNextAttributeFunctionHandler(value, item);
    }
  };

  render() {
    return <div>Vehicle Selector Base</div>;
  }
}

VehicleSelectorBase.propTypes = propTypes;
VehicleSelectorBase.defaultProps = defaultProps;

export default VehicleSelectorBase;
